import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import MainContainer from "../../layout/MainContainer";
import Loader from "../../helpers/constants/Loader";
import { ImageModal } from "../../components";
import { errorToast } from "../../helpers";
import { useLazyGetDiscountByIdQuery } from "../../services/discount";
import { useLazyGetCouponByIdQuery } from "../../services/coupon";
import useTranslation from "../../hooks/Translation";

const DiscountDetails = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const [getDiscountDetails] = useLazyGetCouponByIdQuery();
  const { id } = useParams();
  const [ByIdDetails, setByIdDetails] = useState<any>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [discountData, setDiscountData] = useState<any>("");

  const getDiscountDetail = async () => {
    try {
      const res = await getDiscountDetails({ id }).unwrap();
      if (res?.status === 200) {
        setDiscountData(res?.data);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  // Dummy data simulating the fetched response
  useEffect(() => {
    getDiscountDetail();
  }, []);

  const handleOpenModal = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  return (
    <div>
      <Loader isLoad={false} />{" "}
      {/* Set to false to disable loading indicator for testing */}
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{t.main.discountDetails}</h1>
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-discount")}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item xs={12} className="view_box_list">
                <Grid container spacing={3}>
                  <Grid item xs={4}>
                    <Box>
                      <Typography component="h5">
                        {t.main.discountNameAr}
                      </Typography>
                      <Typography component="p">
                        {discountData?.discount_name_ar || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <Typography component="h5">
                        {t.main.discountNameEn}
                      </Typography>
                      <Typography component="p">
                        {discountData?.discount_name_en || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box>
                      <Typography component="h5">
                        {t.main.discountNameRu}
                      </Typography>
                      <Typography component="p">
                        {discountData?.discount_name_rs || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  {/* <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        Discount Percentage
                      </Typography>
                      <Typography component="p">
                        {ByIdDetails?.percentage || "-"}
                      </Typography>
                    </Box>
                  </Grid> */}

                  {/* Additional Fields */}
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {t.main.discountPer}
                      </Typography>
                      <Typography component="p">
                        {discountData?.discount_percentage || "-"}%
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">{t.main.startDate}</Typography>
                      <Typography component="p">
                        {discountData?.start_date || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">{t.main.endDate}</Typography>
                      <Typography component="p">
                        {discountData?.end_date || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">{t.main.descAr}</Typography>
                      <Typography component="p">
                        {discountData?.description_ar || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">{t.main.descEng}</Typography>
                      <Typography component="p">
                        {discountData?.description_en || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={4} md={6} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">{t.main.descRu}</Typography>
                      <Typography component="p">
                        {discountData?.description_rs || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
      {/* Modal for displaying the larger image */}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        PaperProps={{
          sx: {
            width: 600, // Fixed width
            height: 400, // Fixed height
            maxWidth: "unset", // Prevent maxWidth from overriding the fixed size
            overflow: "hidden", // Prevent scrollbars
          },
        }}
      >
        <DialogContent sx={{ p: 0, position: "relative", overflow: "hidden" }}>
          <IconButton
            aria-label="close"
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "red",
              backgroundColor: "white",
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <img
              src={selectedImage || ""}
              alt="Selected"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default DiscountDetails;
